import React, { useState, useContext, useEffect } from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonButtons, IonButton, IonMenuButton, IonModal, IonLabel, IonFooter } from '@ionic/react';
import { IonGrid, IonRow, IonCol, IonInput } from '@ionic/react';

import { useHistory} from "react-router-dom";

import '../../css/layout.css';
import { ProfileSetting_ContactInfo } from '../../zInternal_Features/merchant/components/ProfileSetting_ContactInfo';
import { ProfileSetting_PaymentInfo } from '../../zInternal_Features/merchant/components/ProfileSetting_PaymentInfo';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

 export function Client_ProfileSetting() {


    let authenticatedClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedClient_context.acctID);
    const [employeeID, setEmployeeID ] = useState(authenticatedClient_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedClient_context.schema);
    let [baseURL, setBaseURL ] = useState(authenticatedClient_context.baseURL);

    let [showContactInfoModal, setShowContactInfoModal] = useState(false);
    let [showPaymentInfoModal, setShowPaymentInfoModal] = useState(false);
    let [showEmployeePayInfoModal, setShowEmployeePayInfoModal] = useState(false);

    let [companyRole, setCompanyRole] = useState(null);
    let [hireDate, setHireDate] = useState(null);
    let [hourlyPay, setHourlyPay] = useState(null);
    let [jobFunction, setJobFunction] = useState(null);

    let history = useHistory();

    function handleRoute(event)
    {
        //alert(authenticatedClient_context.authenticated);

        history.push(event);
        //window.location.pathname = event;

    }

    useEffect(() => {

        let formData = new FormData();
        formData.append('Tracker', 74800);
        formData.append('user', acctID);
        formData.append('xEmployeeID', employeeID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch(baseURL+'userAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setCompanyRole(cols[1]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                }
        })

    }, []);


    //const xTracker = this.state.Tracker;
    //const xUsername = this.state.pUsername;
    //const xPassword = this.state.pPassword;

    //alert("In Profile Setting");
    //alert(this.state.schema);

    return (
        <React.Fragment>
            
            {/*<App_Header></App_Header>*/}

            <IonHeader style={{color: 'white'}}>
                <IonGrid>
                    {authenticatedClient_context.authenticated != null && <IonRow>
                        <IonCol style={{ textAlign: 'left' }} size='4'>
                            <IonTitle >{authenticatedClient_context.employeeCompany}</IonTitle>
                        </IonCol>
                        <IonCol style={{ textAlign: 'left' }} size='6'>
                            <IonTitle >{authenticatedClient_context.employeeFirstName + ' ' + authenticatedClient_context.employeeLastName}</IonTitle>
                        </IonCol>
                        <IonCol className='gh_top_links_col_right' size='2'>
                            <IonMenuButton className="custom-menu-button"  fill={'clear'}>M</IonMenuButton>
                        </IonCol>
                    </IonRow>}
                    <IonRow>
                        <IonCol>
                            <h3>PROFILE SETTINGS</h3>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
            <IonContent className='grid_content'>
                <IonGrid>
                            <IonRow>
                                <IonCol> Employee ID: </IonCol>
                                <IonCol> {employeeID} </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol> Company Role: </IonCol>
                                <IonCol> {companyRole} </IonCol>
                            </IonRow>                                
                            <IonRow>
                                <IonCol> Hire Date: </IonCol>
                                <IonCol> {hireDate} </IonCol>
                            </IonRow>                                
                            <IonRow>
                                <IonCol> Bi/Weekly Pay: </IonCol>
                                <IonCol> {hourlyPay} </IonCol>
                            </IonRow>                                
                            <IonRow>
                                <IonCol> Job Function: </IonCol>
                                <IonCol> {jobFunction} </IonCol>
                            </IonRow>
                </IonGrid>
                <IonGrid>
                    <IonRow>
                        <IonCol size='6'>
                            <h3 >Contact Info</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton onClick={() => setShowContactInfoModal(true)}> View  </IonButton>
                        </IonCol>           
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3 >Payment Info</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton onClick={() => setShowPaymentInfoModal(true)}> View  </IonButton>
                        </IonCol>           
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3 >Employee Pay</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton onClick={() => setShowEmployeePayInfoModal(true)}> View  </IonButton>
                        </IonCol>           
                    </IonRow>
                </IonGrid>

                <ProfileSetting_ContactInfo openModal={ showContactInfoModal } closeModal={() => setShowContactInfoModal(false)}></ProfileSetting_ContactInfo>

                <ProfileSetting_PaymentInfo openModal={ showPaymentInfoModal } closeModal={() => setShowPaymentInfoModal(false)}></ProfileSetting_PaymentInfo>


            </IonContent>
            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonButton onClick={() => handleRoute('/clientMainPageApp')}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>

        </React.Fragment>

    );
};



export default Client_ProfileSetting;